import { CartItem, CartResponse, Product } from "../sdk/types"

const eeProductDetailView = (product: Product) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "eeProductDetailView",
        ecommerce: {
            currencyCode: product.price.currency.name,
            detail: {
                products: [
                    {
                        id: product.id,
                        name: product.name.long,
                        price: product.price.current.taxed,
                    },
                ],
            },
            items: [
                {
                    item_id: product.id,
                    item_name: product.name.long,
                    price: product.price.current.taxed,
                },
            ],
        },
    })
}

const eeAddToCart = (product: CartItem, quantity: number, currency: string, cart: CartResponse) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "eeAddToCart",
        ecommerce: {
            currencyCode: currency,
            purchase: {
                actionField: {
                    id: cart.name,
                    revenue: cart.price.pay_now,
                    tax: cart.price.tax.amount,
                },
            },
            add: {
                products: [
                    {
                        id: product.product.id,
                        name: product.product.name.long,
                        price: product.price.amount_taxed,
                        quantity: quantity,
                    },
                ],
            },
            items: [
                {
                    item_id: product.product.id,
                    item_name: product.product.name.long,
                    price: product.price.amount_taxed,
                    quantity: quantity,
                },
            ],
        },
    })
}

const eeRemovalFromCart = (product: CartItem, quantity: number, currency: string, cart: CartResponse) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "eeRemovalFromCart",
        ecommerce: {
            currencyCode: currency,
            purchase: {
                actionField: {
                    id: cart.name,
                    revenue: cart.price.pay_now,
                    tax: cart.price.tax.amount,
                },
            },
            remove: {
                products: [
                    {
                        id: product.product.id,
                        name: product.product.name.long,
                        price: product.price.amount_taxed,
                        quantity: quantity,
                    },
                ],
            },
            items: [
                {
                    item_id: product.product.id,
                    item_name: product.product.name.long,
                    price: product.price.amount_taxed,
                    quantity: quantity,
                },
            ],
        },
    })
}

const eeCheckoutSteps = { address: 1, shipping: 2, payment: 3, confirmation: 4 } as const

const eeCheckout = (products: CartItem[], step: number, currency: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "eeCheckout",
        ecommerce: {
            currencyCode: currency,
            checkout: {
                actionField: { step: step },
                products: products.map(p => {
                    return {
                        id: p.product.id,
                        name: p.product.name.long,
                        price: p.price.amount_taxed,
                        quantity: p.quantity,
                    }
                }),
            },
            items: products.map(p => {
                return {
                    item_id: p.product.id,
                    item_name: p.product.name.long,
                    price: p.price.amount_taxed,
                    quantity: p.quantity,
                }
            }),
        },
    })
}

const eePurchaseSuccess = (cart: CartResponse, currency: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "eePurchaseSuccess",
        ecommerce: {
            currencyCode: currency,
            purchase: {
                actionField: {
                    id: cart.name,
                    revenue: cart.price.pay_now,
                    tax: cart.price.tax.amount,
                    shipping: cart.shipping?.costs,
                },
                products: cart.items.map(i => {
                    return {
                        id: i.product.id,
                        name: i.product.name.long,
                        price: i.price.amount_taxed,
                        quantity: i.quantity,
                    }
                }),
            },
            items: cart.items.map(i => {
                return {
                    item_id: i.product.id,
                    item_name: i.product.name.long,
                    price: i.price.amount_taxed,
                    quantity: i.quantity,
                }
            }),
        },
    })
}

const eeCustomerType = (guestCustomer: boolean) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "eeCustomerType",
        ecommerce: {
            customer_type: guestCustomer ? "new" : "returning",
        },
    })
}

const gtagEvent = (name: string, properties: any) => {
    window.dataLayer = window.dataLayer || []
    function gtag(...args: any[]) {
        window.dataLayer?.push(args)
    }
    gtag("event", name, properties)
}

export {
    eeProductDetailView,
    eeAddToCart,
    eeRemovalFromCart,
    eeCheckoutSteps,
    eeCheckout,
    eePurchaseSuccess,
    eeCustomerType,
    gtagEvent,
}
